export default {
	'auth': {
		'client': '4b983ed0-5d5a-11ea-bd94-b9afba99747a'
	},
	'url'   : 'https://api.semprefitness.net',
	'stripe': 'pk_live_51JQ6pyEHw2bTdeBcvjf64mxxfJszez4MN2UjVKrJpx17P8GFP86l4gFCDyXku9RcbtBER0P6RffXTa2doPffGdDB00ur7MYf4o'
}
